import type EnType from '../en-US/response';

export default {
  'response.responseDefinitionWasDeleted': 'このResponseは削除されました。再度選択してください。',
  'response.responseIsNotJson': '戻り値のデータ形式が JSON ではありません',
  'response.responseIsNotMsgpack': '戻り値のデータ形式が Msgpack ではありません',
  'response.responseIsNotNoContent': 'このResponseにはBodyが含まれてはいけません',
  'response.resultResponseWithDetail':
    '期待されるResponseは {responseDefinition} であるべきですが、実際には {response} です',
  'response.responseSizeThreshold': '返されたResponseが50MBを超える場合は表示されません',
  'response.imageContentType': '画像: {type}',
  'response.fileContentType': 'ファイル: {type}',
  'response.pdfContentType': 'PDF: {type}',
  'response.videoContentType': 'ビデオ: {type}',
  'response.tooManyCharacters':
    'パフォーマンス上の理由から、レスポンスのコンテンツはフォーマットされていません。',
  'response.saveAsFile': 'Responseをファイルとして保存',
} satisfies typeof EnType;
